import React from "react";

const Divider = ({
  topColor = "#1e90ff",
  bottomColor = "#ff6347",
  thickness = "4px",
  borderRadius = "30px",
  margin_side = "20px"
}) => {
  return (
    <div
      style={{
        height: thickness,
        background: `linear-gradient(to top, ${topColor}, ${bottomColor})`,
        border: "none",
        borderBottomLeftRadius: borderRadius,
        borderBottomRightRadius: borderRadius,
        marginLeft: margin_side,
        marginRight: margin_side
      }}
    />
  );
};

export default Divider;
